(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  document.querySelectorAll('[data-support-section]').forEach((section) => {
    const source = section.querySelector('[data-support-source]');
    const reason = section.querySelector('[data-support-reason]');
    const orderField = section.querySelector('[data-order-field]');
    const orderInput = section.querySelector('[data-order-input]');
    const productField = section.querySelector('[data-product-field]');
    const productInput = section.querySelector('[data-product-input]');
    const productRequired = section.querySelector('[data-product-required]');

    if (!source || !reason || !orderField || !orderInput || !productField || !productInput) return;

    const updateFields = () => {
      const hasPurchase = source.value && source.value !== 'Devo ancora acquistare';
      const needsOrder = hasPurchase && (reason.value === 'Domanda su un prodotto acquistato' || reason.value === 'Richiesta manuale prodotto');
      const needsProduct = reason.value === 'Domanda su un prodotto che vorrei acquistare';
      const showsProduct = needsProduct || reason.value === 'Richiesta manuale prodotto';

      orderField.hidden = !needsOrder;
      orderInput.required = needsOrder;
      if (!needsOrder) orderInput.value = '';

      productField.hidden = !showsProduct;
      productInput.required = needsProduct;
      if (productRequired) productRequired.hidden = !needsProduct;
      if (!showsProduct) productInput.value = '';
    };

    source.addEventListener('change', updateFields);
    reason.addEventListener('change', updateFields);
    updateFields();
  });

  } catch(e) { console.error(e); }
})();
})();
